export const mangroGroupModel = {
    label: 'Groupe mangrove',
    tableName: 'mangroGroup',
    properties: [
        {
            label: 'Site',
            id: 'village',
            isForeignKey: true,
            column_name: 'name', // On cherche le village par son nom
            table_column: 'parent', // On stocke l'ID du village dans 'parent'
            type: 'text',
            example: 'Antsahampano', // Exemple de nom de village/site
            required: true
        },
        {
            label: 'Nom',
            id: 'name',
            type: 'text',
            example: 'MG-DIANA-001', // Exemple de nom de groupe
            required: true
        }
    ]
}
